module.exports = __webpack_public_path__ + "static/media/slider2.7a280bda.jpg";